/** A csővezeték-sávmérő szakaszainak számítása. */
export interface CsoBemenet { kulcs: string; db: number }
export interface CsoSzakasz extends CsoBemenet { flex: number; szin: string; kivalasztva: boolean;
  /** 0 darabos szakasz: csak vékony, felirat nélküli jel. */ jel: boolean;
  /** Túl keskeny a felirathoz: csak a szám látszik. */ kompakt: boolean }

/** Az átmenet pontjai (a tokenekből): smaragd 0%, közép 55%, arany 100%. */
const KOZEP_POZICIO = 0.55;
/** Az összes darabszám ezen hányada alatt a szakasz felirata nem fér el, csak a szám látszik. */
const KOMPAKT_HATAR = 0.15;

/** A szakasz színe a pozíciója szerint a sáv-átmeneten (smaragd → közép → arany), tokenekből. */
function szakaszSzin(index: number, osszes: number): string {
  const t = osszes > 1 ? index / (osszes - 1) : 0;
  if (t <= KOZEP_POZICIO) {
    const x = Math.round((t / KOZEP_POZICIO) * 100);
    return `color-mix(in srgb, var(--szin-sav-kozep) ${x}%, var(--szin-kiemelt))`;
  }
  const x = Math.round(((t - KOZEP_POZICIO) / (1 - KOZEP_POZICIO)) * 100);
  return `color-mix(in srgb, var(--szin-masodlagos) ${x}%, var(--szin-sav-kozep))`;
}

export function csoSzakaszok(szakaszok: readonly CsoBemenet[], kivalasztott?: string | null): CsoSzakasz[] {
  const osszes = szakaszok.reduce((a, sz) => a + sz.db, 0);
  return szakaszok.map((sz, i) => ({
    ...sz,
    jel: sz.db === 0,
    kompakt: sz.db > 0 && sz.db / osszes < KOMPAKT_HATAR,
    flex: sz.db,
    szin: szakaszSzin(i, szakaszok.length),
    kivalasztva: kivalasztott != null && sz.kulcs === kivalasztott,
  }));
}
